module.exports = __webpack_public_path__ + "img/avatar.5b175073.svg";